import { put, takeLatest, select } from 'redux-saga/effects';

import filter from 'lodash/filter';

import { clearMask } from '../../../components/CreditCard/libs';
import { formatError } from '../../../libs';
import { Types, Creators as CreditCardCreators } from '../../reducers/creditCard';
import getState from '../../utils/getState';

function* updateCreditCard({ data }) {
  try {
    const { creditCard } = yield select(getState);
    const { values } = data;
    const updatedCreditCard = { ...creditCard.getIn(['creditCard']) };

    Object.keys(values).forEach((key) => {
      if (values[key] !== updatedCreditCard[key]) {
        updatedCreditCard[key] = key === 'numero' ? clearMask(values[key]) : values[key];
        updatedCreditCard.updateAt = new Date().getTime();
        updatedCreditCard.firstLoad = false;
      }
    });

    const totalPaid = filter(
      creditCard.getIn(['creditCards']),
      (item) => item.sequencia !== updatedCreditCard.sequencia
    ).reduce((acc, item) => acc + parseFloat(item.valor || 0), 0);

    const result = {
      creditCards: { ...creditCard.getIn(['creditCards']) },
      creditCard: updatedCreditCard,
      totalPending: creditCard.getIn(['totalValueOrder']) - Number((totalPaid + updatedCreditCard.valor).toFixed(2)),
    };

    yield put(CreditCardCreators.updateCreditCardSuccess({ ...result }));
  } catch (error) {
    yield put(CreditCardCreators.updateCreditCardError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.UPDATE_CREDIT_CARD_REQUEST, updateCreditCard);
}
